import React from 'react';
import { Alert } from '@/components/ui/alert';
import { useThemeConfig } from '@/components/ui/theme-config-provider';
import { useMessages } from '@/locales/messages';
import { useAppUpdateContext } from '@/context/app-update/AppUpdateContext';

/**
 * Mostra un avviso per aggiornare l'app.
 * Su Android avvia l'update in-app, mentre su iOS apre l'App Store.
 */
const AppUpdateBanner: React.FC = () => {
  const { visible, mandatory, changelog, startUpdate, dismiss } =
    useAppUpdateContext();
  const { theme } = useThemeConfig();
  const { appUpdate } = useMessages();

  if (!visible) return null;

  return (
    <div className="container px-4">
      <Alert
        role="status"
        className="rounded-md space-y-2 text-center"
        style={{
          backgroundColor: theme.warningColor,
          borderColor: theme.warningColor,
          color: theme.textPrimaryColor,
        }}
      >
        <span className="text-sm">
          {appUpdate.available}
          {changelog && (
            <span className="block text-xs mt-1">{changelog}</span>
          )}
        </span>
        <div className="flex justify-center gap-4">
          <button
            onClick={(e) => {
              e.preventDefault();
              startUpdate();
            }}
            style={{
              backgroundColor: theme.cardBackgroundColor,
              color: theme.primaryColor,
              borderRadius: theme.buttonBorderRadius,
              padding: theme.buttonPadding,
              fontWeight: theme.buttonFontWeight,
              transitionDuration: theme.transitionSpeed,
            }}
          >
            {appUpdate.updateNow}
          </button>
          {!mandatory && (
            <button
              onClick={dismiss}
              aria-label={appUpdate.dismissLabel}
              style={{
                backgroundColor: theme.cardBackgroundColor,
                color: theme.textColor,
                borderRadius: theme.buttonBorderRadius,
                padding: theme.buttonPadding,
                fontWeight: theme.buttonFontWeight,
                transitionDuration: theme.transitionSpeed,
              }}
            >
              {appUpdate.dismiss}
            </button>
          )}
        </div>
      </Alert>
    </div>
  );
};

export default AppUpdateBanner;
